import { render, staticRenderFns } from "./TaskBlockEdit.vue?vue&type=template&id=bf1b2b1a&scoped=true&"
import script from "./TaskBlockEdit.vue?vue&type=script&lang=js&"
export * from "./TaskBlockEdit.vue?vue&type=script&lang=js&"
import style0 from "./TaskBlockEdit.vue?vue&type=style&index=0&id=bf1b2b1a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf1b2b1a",
  null
  
)

export default component.exports